import React from 'react';

import Checkbox from 'components/Forms/checkbox';

const data = [
  { label: 'Learner Community Forum', name: 'allowLearnerCommunityForum' },
  { label: 'Admin Community Forum', name: 'allowAdminCommunityForum' },
  { label: 'Advertisement', name: 'enableAdvertisement' },
  { label: 'Podcast', name: 'enablePodcast' },
  { label: 'Socialties mobile app', name: 'isSocialTiesEnabled' },
  { label: 'Show fixtures and results', name: 'allowFixturesAndResults' },
  { label: 'Enable ticketing', name: 'isTicketingEnabled' },
];

export default function({ handleCheckbox, client }) {
  return (
    <>
      {data.map(datum => (
        <Checkbox
          key={datum.label}
          label={datum.label}
          checked={client[datum.name]}
          name={datum.name}
          onChange={handleCheckbox}
        />
      ))}
    </>
  );
}
